<template>
<div>
    <!-- <div class="menu">
        <div class="menu-item" v-for="item in menuList" :key="item.id" @click="routerLink(item)">{{item.name}}</div>
    </div> -->
    <van-tabbar v-model="active">
        <van-tabbar-item :icon="item.icon" v-for="item in menuList" :key="item.id" @click="routerLink(item)">{{item.name}}</van-tabbar-item>
    </van-tabbar>
</div>
</template>

<script>
export default {
    data() {
        return {
            active: 0,
            menuList: [{
                    id: 1,
                    name: "首页",
                    url: '/',
                    icon:'wap-home'
                },
                {
                    id: 2,
                    name: "院校",
                    url: "school",
                    icon:"description"
                },
                {
                    id: 3,
                    name: "我的",
                    url: '/userCenter',
                    icon:"friends-o"
                }
            ]
        }
    },
    methods: {
        routerLink(item) {
            this.$router.push(item.url)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.van-tabbar{
    height: 60px !important;
}
.menu {
    width: 100vw;
    position: fixed;
    bottom: 0;
    display: flex;
}

.menu-item {
    width: 33.3vw;
    text-align: center;
    line-height: 4rem;
    background: #f2f2f2;
}
</style>
